"use strict";

angular.module("customer")
.component("orderedQuantity", {
    bindings: {
        quantity: "=",
        secondaryQuantity: "<?",
        catalogEntry: "=",
        catalogEntryVariant: "=?",
        shouldShowSuggestedOrderMultiplier: "<?",
        forceInputText: "<?",
        ignoreAutoSave: "<?",
        vendor: "<",
        useVariableMeasure: "<?",
        isCustomDiscount: "<?"
    },
    templateUrl: require("./quantity.component.html"),
    controller: function(
        $scope, PatternService, StocksService, CartItemService, ModalService, common,
        IS_MOBILE, IS_MOBILE_APP
    ) {
        var _this = this;
        var initialQuantity = this.quantity || 0;
        $scope.isTouchOptimized = !this.forceInputText && (IS_MOBILE || IS_MOBILE_APP);
        $scope.pattern = PatternService;

        $scope.isProductVariant = !!(
            _this.vendor.allow_product_variants
            && _this.catalogEntry.product.has_variants
            && _this.catalogEntryVariant
        );

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.quantity);
        };

        this.isOrderedButtonDisabled = function() {
            if ($scope.isProductVariant) {
                return StocksService.isProductVariantOutOfStock(this.catalogEntryVariant) && parseFloat(this.quantity) === 0;
            }
            return StocksService.isOutOfStock(this.catalogEntry) && parseFloat(this.quantity) === 0;
        };

        this.isQuantityChanged = function() {
            return initialQuantity !== this.quantity;
        };

        this.getErrorClass = function() {
            var isQuantityValid = CartItemService.isCartItemQuantityValid(
                this.catalogEntry.quantity_min,
                this.catalogEntry.quantity_max,
                this.quantity
            );
            var totalQuantity = parseFloat(this.quantity);
            if (typeof this.secondaryQuantity !== 'undefined') {
                totalQuantity += parseFloat(this.secondaryQuantity);
            }
            var isInventoryQuantityValid = (
                    !this.vendor.block_order_when_out_of_stock || CartItemService.isProductInventoryQuantityValid(
                    this.catalogEntry.inventory_quantity,
                    totalQuantity
                )
            );
            if ($scope.isProductVariant) {
                isInventoryQuantityValid = (
                    !this.vendor.block_order_when_out_of_stock || CartItemService.isProductInventoryQuantityValid(
                        this.catalogEntryVariant.inventory_quantity,
                        totalQuantity
                    )
                );
            }
            var isProductMultiplierValid = CartItemService.isProductMultiplierValid(
                this.catalogEntry.packaging_quantity,
                this.quantity
            );

            var isOrderedWithQuantityOfMeasureValid;
            if (this.isCustomDiscount) {
                isOrderedWithQuantityOfMeasureValid = CartItemService.isDiscountedWithQuantityOfMeasureValid(
                    this.catalogEntry,
                    this.vendor,
                    this.catalogEntry.discounted_order_quantity,
                    this.catalogEntry.discounted_total_measure
                );
            } else {
                isOrderedWithQuantityOfMeasureValid = CartItemService.isOrderedWithQuantityOfMeasureValid(this.catalogEntry, this.vendor);
            }

            return {
                'quantity-error': (
                    (!isQuantityValid || !isInventoryQuantityValid || !isProductMultiplierValid || !isOrderedWithQuantityOfMeasureValid)
                    && !this.isOrderedButtonDisabled()
                ),
                'value-changed': this.isQuantityChanged(),
                'value-unchanged': !this.isQuantityChanged(),
                'disabled': this.isOrderedButtonDisabled()
            }
        };

        this.changeQuantity = function($event) {
            $event.stopPropagation();
            var catalogEntry = this.catalogEntry;
            var currentQuantity = this.quantity;

            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("./modals/ordered-quantity.modal.html"),
                controller: "OrderedQuantityModalController",
                controllerAs: "orderedQuantityCtrl",
                inputs: {
                    $attrs: {
                        originalQuantity: currentQuantity,
                        inventoryQuantity: catalogEntry.inventory_quantity,
                        quantityMin: catalogEntry.quantity_min,
                        quantityMax: catalogEntry.quantity_max,
                        packagingQuantity: catalogEntry.packaging_quantity,
                        availableQuantities: catalogEntry.minimal_available_quantities,
                        suggestedOrderMultiplier: catalogEntry.suggested_order_multiplier,
                        vendor: _this.vendor
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(quantity) {
                    modal.element.remove();
                    if (quantity >= 0 && quantity !== currentQuantity) {
                        _this.saveQuantity(quantity);
                    }
                });
            });
        };

        this.saveQuantity = function(quantity) {
            if (this.ignoreAutoSave) {
                return;
            }

            var promise
            if (this.isCustomDiscount) {
                promise = CartItemService.saveDiscountedQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor, this.catalogEntry.custom_discounted_price
                );
            } else {
                promise = CartItemService.saveSaleQuantity(this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor);
            }

            promise.then(function onSuccess() {
                _this.quantity = quantity;
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/ordered-quantity/ordered-quantity.component.js
// module id = 802
// module chunks = 0